import React from 'react'
import * as styles from './process.module.css'

const Process = () => {
  return (
    <section>
      <div className={styles.process}>
        <div className={styles.processWrapper}>
          <h2>Как мы работаем</h2>
          <span className={styles.processDesc}>
            Наша цель создать действительно эффективный веб-сайт для Вас. Для
            этого мы разделили процесс на несколько стадий:
          </span>
          <ul>
            <li>
              <span>1. Сбор данных</span>
              <span>
                Наш менеджер связывается с Вами и узнает все детали и
                информацию. Благодаря этому, мы сможем лучше узнать Ваш бизнес.
              </span>
            </li>
            <li>
              <span>2. Создание прототипа</span>
              <span>
                Дизайнер создает структуру главной страницы Вашего будущего
                веб-сайта. На этой стадии мы так-же добавляем текстовую
                инфорамцию.
              </span>
            </li>
            <li>
              <span>3. Демо-страница</span>
              <span>
                Мы создаем демонстративную версию главной страницы с помощью
                прототипа. Отправляем Вам для одобрения.
              </span>
            </li>
            <li>
              <span>4. Создание веб-сайта</span>
              <span>
                После Вашего одобрения, мы продолжаем работу над дизайном,
                структорой и созданием внутренних страниц Вашего сайта.
              </span>
            </li>
            <li>
              <span>5. Запуск и передача владельцу</span>
              <span>
                Когда веб-сайт закочен, мы передаем его Вам и запускаем
                индексирование поисковыми механизмами.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Process
